// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2706e46b","977":"1ef63c23"}[chunkId] + ".chunk.js";
};